import { QueryBuilder, type RuleGroupType } from 'react-querybuilder';
import { FLAT_AND_COMBINATORS, QUERY_BUILDER_FIELDS } from '../../lib/audienceFields';
import type { FilterErrors } from '../../lib/filterValidation';
import {
  AudienceOperatorSelector,
  AudienceRemoveRule,
  AudienceRuleRow,
  AudienceValueEditor,
  type FilterRulesContext
} from './FilterRules.controls';
import { RulesShell } from './FilterRules.styles';

/* Rows are added and removed by the column mapper, so the builder shows no add, group, combinator, NOT, clone, lock, or drag controls */
const CONTROL_ELEMENTS = {
  rule: AudienceRuleRow,
  valueEditor: AudienceValueEditor,
  operatorSelector: AudienceOperatorSelector,
  removeRuleAction: AudienceRemoveRule,
  addRuleAction: null,
  addGroupAction: null,
  combinatorSelector: null,
  notToggle: null,
  cloneRuleAction: null,
  cloneGroupAction: null,
  lockRuleAction: null,
  lockGroupAction: null,
  removeGroupAction: null,
  dragHandle: null
};

type FilterRulesProps = {
  query: RuleGroupType;
  onQueryChange?: (query: RuleGroupType) => void;
  /** Renders every editor read-only, for saved definitions. */
  disabled?: boolean;
  /** Draws the box around the rule rows; off where the page supplies its own section layout. */
  bordered?: boolean;
  filterErrors?: FilterErrors;
  /** Why each left-out rule is left out, keyed by rule id; shown on its row. */
  droppedReasons?: Record<string, string>;
};

/** The audience rule rows, rendered by react-querybuilder with our field config and controls. */
const FilterRules = ({
  query,
  onQueryChange,
  disabled = false,
  bordered = true,
  filterErrors,
  droppedReasons
}: FilterRulesProps) => {
  const context: FilterRulesContext = { filterErrors, droppedReasons };
  return (
    <RulesShell empty={query.rules.length === 0} bordered={bordered}>
      <QueryBuilder
        fields={QUERY_BUILDER_FIELDS}
        combinators={FLAT_AND_COMBINATORS}
        query={query}
        onQueryChange={onQueryChange}
        controlElements={CONTROL_ELEMENTS}
        context={context}
        disabled={disabled}
        listsAsArrays
        resetOnOperatorChange
        autoSelectField={false}
      />
    </RulesShell>
  );
};

export default FilterRules;
